import { render } from "./mousewheelDisable.vue?vue&type=template&id=335026b6"
import script from "./mousewheelDisable.vue?vue&type=script&lang=js"
export * from "./mousewheelDisable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__